import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import type UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import {
    accountScopeOwaUserConfigurationProperties,
    accountScopeUserOptionsProperties,
    AccountScopeUserSettings,
    accountScopeViewStateConfigurationProperties,
} from 'owa-service/lib/types/AccountScopeUserSettings';

function moveProperties<T>(from: T | undefined, to: T, keys: readonly (keyof T)[]) {
    if (from) {
        keys.forEach(key => {
            if (key in from) {
                to[key] = from[key];
                delete from[key];
            }
        });
    }
}

export function extractAccountScopeSettingsFromOwaUserConfiguration(
    userConfiguration: OwaUserConfiguration
): AccountScopeUserSettings {
    let accountScopeSettings: AccountScopeUserSettings = {
        SessionSettings: {},
        UserOptions: {},
        ViewStateConfiguration: {},
        defaultFolderNameToIdMap: new Map(),
        defaultFolderIdToNameMap: new Map(),
    };

    moveProperties<UserOptionsType>(
        userConfiguration.UserOptions,
        accountScopeSettings.UserOptions,
        accountScopeUserOptionsProperties
    );
    moveProperties<OwaViewStateConfiguration>(
        userConfiguration.ViewStateConfiguration,
        accountScopeSettings.ViewStateConfiguration,
        accountScopeViewStateConfigurationProperties
    );
    moveProperties<OwaUserConfiguration>(
        userConfiguration,
        accountScopeSettings,
        accountScopeOwaUserConfigurationProperties
    );

    const sessionSettings = userConfiguration.SessionSettings;
    const folderNames = sessionSettings?.DefaultFolderNames;
    const folderIds = sessionSettings?.DefaultFolderIds;

    if (folderNames !== undefined && folderIds !== undefined) {
        folderNames.forEach((defaultFolderName, i) => {
            if (defaultFolderName) {
                const folderId = folderIds[i];
                if (folderId) {
                    accountScopeSettings.defaultFolderNameToIdMap.set(
                        defaultFolderName,
                        folderId.Id
                    );
                    accountScopeSettings.defaultFolderIdToNameMap.set(
                        folderId.Id,
                        defaultFolderName
                    );
                }
            }
        });
    }

    delete sessionSettings?.DefaultFolderNames;
    delete sessionSettings?.DefaultFolderIds;

    return accountScopeSettings;
}
